import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { ActivationCodeComponent } from './activation-code.component';

// @ngInject
let stateConfig = ($stateProvider: ng.ui.IStateProvider) => {

    $stateProvider
        .state('registration.activation-code', {
            url: '/activation-code',
            data: {
                authorisationLevel: 0,
                pageTitle: 'Activation Code'
            },
            ncyBreadcrumb: {
                label: 'Codice Attivazione',
            },
            params: {
                activationCode: ''
            },
            'views': {
                'multiContentRegistration': {
                    template: '<activation-code flex="100"></activation-code>'
                }
            }
        });
};

stateConfig.$inject = ['$stateProvider'];

export const ActivationCodeModule: string = ng
    .module('activation-code', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('activationCode', ActivationCodeComponent)
    .config(stateConfig)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/registration/activation-code/activation-code.module.ts